import { Grid, Typography, useTheme } from "@mui/material";
import { GetTheme, THEME } from "../../../theme/customThemeProvider";
import { useTranslation } from "react-i18next";

const ReachImageList = ({
    list,
    needGrayScale=true,
    showLabels=false
}) => {
    const theme = useTheme();
    const {themeMode} = GetTheme();

    const {t} = useTranslation();

    return (
        <>
            <Grid
                direction='row'
                justifyContent='center'
                alignItems='start'
                container
                width='100%'
            >
                {
                    list.map((item, index) => {
                        return <Grid
                            key={index}
                            size={{xs: 3, sm: 2, md: 1.5}}
                            px={2}
                            data-aos="zoom-in-up"
                            data-aos-delay={25 * index}
                            py={{xs: 0.5, md: 1}}
                            direction='row'
                            justifyContent='center'
                            alignItems='end'
                        >
                            {
                                themeMode === THEME.LIGHT || !needGrayScale
                                ?
                                <img 
                                    src={item.src} 
                                    alt={item.alt}
                                    width='100%'
                                />
                                :
                                <div
                                    style={{
                                        width: '100%',
                                        aspectRatio: 1/1,
                                        backgroundColor: theme.palette.text.secondary, // target color
                                        maskImage: `url(${item.src})`,
                                        maskRepeat: "no-repeat",
                                        maskSize: "contain",
                                        maskPosition: "center",
                                        WebkitMaskImage: `url(${item.src})`,
                                        WebkitMaskRepeat: "no-repeat",
                                        WebkitMaskSize: "contain",
                                        WebkitMaskPosition: "center",
                                    }}
                                />
                            }

                            {
                                showLabels
                                ?
                                <Typography
                                    fontWeight={500}
                                    fontSize={{xs: 12, lg: 16}}
                                    textAlign='center'
                                    lineHeight={{xs: 1.5, md: 2}}
                                    color={theme.palette.text.secondary}
                                >
                                    {t(item.label)}
                                </Typography>
                                :
                                <></>
                            }
                        </Grid>
                    })
                }
            </Grid>
        </>
    );
}

export default ReachImageList;